import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=7430b956&scoped=true"
import script from "./NotFoundView.vue?vue&type=script&lang=ts"
export * from "./NotFoundView.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=7430b956&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7430b956",
  null
  
)

export default component.exports